export default function() {

	const elements = document.querySelectorAll('.fade-in');
	if (!elements.length) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('visible');
			} else {
				entry.target.classList.remove('visible');
			}
		});
	}, {
		rootMargin: '0px 0px -10% 0px'
	});

	elements.forEach(element => observer.observe(element));
}